import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { BomTableService } from '../bom-table/bom-table.service';
import { ProjectService } from '../../api/services/project.services';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationOrder } from '../../api/models/order-confirmation';
import { RogLinesTableComponent } from '../rog-confirmation-dialog/rog-lines-table/rog-lines-table.component';
import { FilesModalComponent } from '../comments/files-modal/files-modal.component';
import { ProjectOrderInput } from '../../api/models/project-summary';
import { TasksService } from '../../api/services/tasks.service';
import { RogDetail, RogDetailInput, RogSkuDetail, RogRetract } from '../../api/models/rog';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ToastrService } from 'ngx-toastr';
import { RetractModalComponent } from '../retract-modal/retract-modal.component';
import { MarketService } from '../../api/services/market.service';
import { Market } from '../../api/models/market-model';
import { PreviewImageComponent } from '../preview-image/preview-image.component';
import { WarrantyCreation } from '../../api/models/warranty';
import { UserService } from '../../api/services/user.service';
import { AuthService } from '../../api/services/auth.service';
import { User } from '../../api/models/user-model';
import { HttpErrorResponse } from '@angular/common/http';
import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { min } from 'rxjs/operator/min';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { AnalyticsService } from '../../api/services/analytics.service';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss'],
  providers: [BomTableService]
})
export class OrderConfirmationComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private location: Location,
    private modalService: NgbModal,
    private tasksService: TasksService,
    private toastr: ToastrService,
    private userService: UserService,
    private marketService: MarketService,
    private authService: AuthService,
    private calendar: NgbCalendar,
    private analyticsService: AnalyticsService
  ) { }


  @ViewChild(RogLinesTableComponent)
  @ViewChild(NgbDropdown) dropdown: NgbDropdown;
  private linesTable: RogLinesTableComponent;
  private userDetails: User;
  fileIds = [];

  loading = true;

  tesscoAccountNumber: string;
  companyName: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  sku: string;
  orderNumber: string;
  serialNumber: string;
  manufacturerPartNumber: string;
  quantity: number;
  replacementNeeded: boolean = false;
  description: string;
  troubleshootTicketNumber: string;
  rmaNumber: string;
  addressOfDefective: string;
  addressToShipReplacement: string;
  addressOfDefectiveLine2: string;
  defectiveAddressCity: string;
  defectiveAddressState: string;
  addressToShipReplacementLine2: string;
  addressToShipReplacementCity: string;
  addressToShipReplacementState: string;
  addressToShipReplacementPostalCode: string;
  defectiveAddressPostalCode: string;

  addressToShipToLine1: string;
  addressToShipToLine2: string;
  addressToShipToCity: string;
  addressToShipToState: string;
  addressToShipToPostalCode: string;
  addressToShipFirstName:string;
  addressToShipLastName:string;
  addressToShipToPhone:string;
  addressToShipToEmail:string;

  warranty: WarrantyCreation;

  shipmentProblems = ['Short', 'Wrong', 'Damaged', 'Over'];
  problemSelected = '';
  showReportDialog = false;
  showWarrantyForm = false;
  linesSelected: RogSkuDetail[] = [];
  lines = [];
  order: ConfirmationOrder;
  rogDetail: RogDetail;
  today: Date;
  comments = [];

  problemQty: number = 0;
  problemComment = '';
  // rogTask: RogTaskInfo;
  market: Market;
  rogTaskDetails : boolean = false;

  errorMessage: string[] = [];
  rogLineStatus : boolean = true;

  backToSearch: string;
  validShipmentValues: string[] = ["Short", "Wrong", "Damaged", "Over", "Warranty Claimed", "Received"]
  
  problemLabel = '';
  reportedByFirstName = '';
  reportedByLastName = '';
  minDate: NgbDateStruct;
  replacementDate;
  keepexcess = 'no';
  packagedamaged = 'no' ;
  damageonbol = 'no';
  addressToShipCompanyName = '';
  liftgaterequired = false;
  sameshipmentaddress = false;
  submittedByFirstName = '';
  submittedByLastName = '';
  

  goBack(): void {
    this.location.back();
  }

  private onUpdateError(errorMessage) {
    this.toastr.error('Error updating ROG. ' + errorMessage, 'Fail!', {
      timeOut: 5000,
      positionClass: 'toast-bottom-right'
    });
  }

  private displayFailureMsg(message, text) {
    this.toastr.error(message, text, {
      timeOut: 5000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onUpdateSuccess(message) {
    this.showReportDialog = false;
    this.dropdown.close();
    if(message) {
      this.toastr.success(message, 'Sent!', {
        timeOut: 1000,
        positionClass: 'toast-bottom-right'
      });
    } else {
      this.toastr.success('ROG saved!!!', 'OK!', {
        timeOut: 1000,
        positionClass: 'toast-bottom-right'
      });
    }
  }

  onLinesUpdate(linesSelected: RogSkuDetail[]) {
    this.showWarrantyForm = false;
    this.showReportDialog = false;
    this.linesSelected = linesSelected;
    this.dropdown.close();
  }
  
  cantConfirmItems() {
    return this.linesSelected.some(line => this.validShipmentValues.includes(line.status));
  }

  allLinesHaveStatus() {
    if (this.linesTable) {
      return this.linesTable.lines.every(line => line.status !== '-');
    } else {
      return this.rogDetail.receiptOfGoodsSkus.every(item => item.status !== '-');
    }
  }

  openFilesModal() {
    const modalRef = this.modalService.open(FilesModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.type = 'Add';

    modalRef.result.then(result => {
      this.fileIds = result;
    });
  }

  selectProblem(problem: string) {
    this.selectProblemLabel(problem);
    this.problemSelected = problem;
    this.problemComment = '';
    this.problemQty = 0;
    this.showReportDialog = true;

    this.keepexcess = 'no';
    this.damageonbol = 'no';
    this.packagedamaged = 'no';
    this.sameshipmentaddress = false;
    this.liftgaterequired = false;
    this.replacementDate = '';
    this.addressToShipFirstName = '';
    this.addressToShipLastName = '';
    this.addressToShipToEmail = '';
    this.addressToShipToPhone = '';

    
    this.addressToShipToLine1 = this.order.street;
    this.addressToShipCompanyName = this.order.shipToName;
    this.addressToShipToCity= this.order.city;
    this.addressToShipToState = this.order.region;
    this.addressToShipToPostalCode = this.order.postalCode;
    this.fileIds = [];
  }

  selectProblemLabel(problem){
    switch(problem){
      case "Short": 
        this.problemLabel = "How many items are short?";
        break;
      case "Wrong":
        this.problemLabel = "Qty of incorrect product received";
        break;
      case "Damaged":
        this.problemLabel = "How many items are damaged?";
        break;  
      case "Over":
        this.problemLabel = "How many items are over?";
        break;
    }
  }

  openWarrantyForm() {
    this.showWarrantyForm = true;
    this.tesscoAccountNumber = this.rogDetail.accountNumber;
    this.orderNumber = this.rogDetail.orderNumber;
    this.sku = this.linesSelected[0].sku;
    this.manufacturerPartNumber = this.linesSelected[0].mpn;
    let organizationId = this.userDetails["Organization ID"];
    // this.userService.findOrganizationById(organizationId).subscribe(org => {
    //   this.companyName = org.Name;
    // });
    this.companyName = this.order.shipToName;
    this.addressToShipReplacement = this.order.street;
    this.addressToShipReplacementCity = this.order.city;
    this.addressToShipReplacementState = this.order.region;
    this.addressToShipReplacementPostalCode = this.order.postalCode;
  }

  submitWarrantyForm() {
    if(this.quantity < 0){
      this.displayFailureMsg('Warranty quantity should be more than 0', 'Warning!');
      return;
    }
    if(Number(this.linesSelected[0].deliveryQty) < this.quantity){
      this.displayFailureMsg(this.problemSelected + ' quantity is more than quantity shipped', 'Warning!');
      return;
    }
    if(!this.description || this.description.trim().length == 0){
      this.displayFailureMsg('Warranty defect description can\'t be blank', 'Warning!');
      return;
    }
    if(this.firstName == null || this.lastName == null || this.tesscoAccountNumber == null || this.companyName == null || this.phoneNumber == null || this.email == null || this.sku == null || this.serialNumber == null || 
      this.orderNumber == null || this.manufacturerPartNumber == null || this.quantity == null || this.troubleshootTicketNumber == null){
      this.displayFailureMsg('Warranty Creation Model is not Valid. Please ensure First & Last Name, Account Number, Phone Number, Email, Order Number, SKU, Serial Number, Manufacturer Part Number, Troubleshoot Ticket Number , and Quantity are all being sent.', 'Warning!');
      return;
    }
    if(this.quantity == 0 || this.quantity > Number(this.linesSelected[0].deliveryQty)){
      this.displayFailureMsg('Warranty claim form quantity should be more than 0 and less than or equal to shipped quantity.', 'Warning!');
      return;
    }
    if((this.email || this.email.trim().length > 0) && !this.validateEmail(this.email)){
      this.displayFailureMsg('Entered email address is not valid', 'Warning!');
      return;
    }
    this.warranty = new WarrantyCreation();
    this.warranty.receiptOfGoodsId =this.rogDetail.id;
    this.warranty.accountNumber = this.rogDetail.accountNumber;
    this.warranty.companyName = this.companyName;
    this.warranty.firstName = this.firstName;
    this.warranty.lastName = this.lastName;
    this.warranty.phoneNumber = this.phoneNumber;
    this.warranty.email = this.email;
    this.warranty.sku = this.sku;
    this.warranty.parentSku = this.linesSelected[0].parentSku;
    this.warranty.serialNumber = this.serialNumber;
    this.warranty.orderNumber = this.rogDetail.orderNumber;
    this.warranty.manufacturerPartNumber = this.manufacturerPartNumber;
    this.warranty.quantity = this.quantity;
    this.warranty.replacementNeeded = this.replacementNeeded;
    this.warranty.description = this.description;
    this.warranty.troubleshootTicketNumber = this.troubleshootTicketNumber;
    this.warranty.rmaNumber = this.rmaNumber;
    this.warranty.addressOfDefective = this.addressOfDefective;
    this.warranty.addressToShipReplacement = this.addressToShipReplacement;
    this.warranty.addressOfDefectiveLine2 = this.addressOfDefectiveLine2;
    this.warranty.defectiveAddressCity = this.defectiveAddressCity;
    this.warranty.defectiveAddressState = this.defectiveAddressState;
    this.warranty.addressToShipReplacementLine2 = this.addressToShipReplacementLine2;
    this.warranty.addressToShipReplacementCity = this.addressToShipReplacementCity;
    this.warranty.addressToShipReplacementState = this.addressToShipReplacementState;
    this.warranty.addressToShipReplacementPostalCode = this.addressToShipReplacementPostalCode;
    this.warranty.defectiveAddressPostalCode = this.defectiveAddressPostalCode;
    this.warranty.receiptOfGoodsSkuId =  this.linesSelected[0].id;
    this.warranty.submittedByFirstName = this.submittedByFirstName;
    this.warranty.submittedByLastName = this.submittedByLastName;

    this.tasksService.createWarranty(this.warranty).subscribe(data => {
      this.sendDataToAnalytics(this.sku, "warranty_claim");
      this.onWarrantyFormUpdateSuccess();
      this.fetchRogAndFillComments();
      // this.linesTable.setStatus(this.linesSelected, this.problemSelected);
    }, error => {
      const err = error.error;
      this.onWarrantyFormUpdateError(err.message);
    });
  }


  private onWarrantyFormUpdateSuccess() {
    this.showWarrantyForm = false;
    this.dropdown.close();
    this.toastr.success('Warranty Form saved!!!', 'Success!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onWarrantyFormUpdateError(message) {

     this.toastr.error('Error updating Warranty Form. ' + message, 'Fail!', {
      timeOut: 5000,
      positionClass: 'toast-bottom-right'
    });
  }

  confirmItems() {
    const rogToUpdate = new RogDetailInput();
    rogToUpdate.receiptOfGoodsId =  this.rogDetail.id;
    rogToUpdate.accountNumber = this.rogDetail.accountNumber;
    rogToUpdate.orderNumber =  this.rogDetail.orderNumber;
    this.linesSelected.forEach(lineId => {
      const updatedSku = new RogSkuDetail();
      updatedSku.status = 'Received';
      updatedSku.id = lineId.id;
      updatedSku.sku = lineId.sku;
      updatedSku.parentSku = lineId.parentSku;
      updatedSku.deliveryQty = lineId.deliveryQty;
      updatedSku.mpn = lineId.mpn;

      updatedSku.addressToShipToLine1 = this.addressToShipToLine1;
      updatedSku.addressToShipToCity = this.addressToShipToCity;
      updatedSku.addressToShipToState = this.addressToShipToState;
      updatedSku.addressToShipToPostalCode = this.addressToShipToPostalCode;

      rogToUpdate.receiptOfGoodsSkus.push(updatedSku);
    });
    this.tasksService.updateRogTask(rogToUpdate).subscribe(response => {
      const combinedSkus = this.linesSelected.map(lineId => lineId.sku).join(", ");
      this.sendDataToAnalytics(combinedSkus, "confirm_receipt");
      this.onUpdateSuccess(null);
      this.rogDetail = response;
      this.fillComments();
      // this.linesTable.setStatus(this.linesSelected, 'Received');
      this.getTimer();
      this.loading = false;
      
    }, error => {
      const err = error.error;
      this.onUpdateError(err.message);
       this.loading = false;
    });
  }

  reportProblem() {
    if(this.problemQty < 1){
      this.displayFailureMsg(this.problemSelected + ' quantity should be more than 0', 'Warning!');
      return;
    }
    if(Number(this.linesSelected[0].deliveryQty) < this.problemQty){
      this.displayFailureMsg(this.problemSelected + ' quantity is more than quantity shipped', 'Warning!');
      return;
    }
    if(!this.problemComment || this.problemComment.trim().length == 0){
      this.displayFailureMsg(this.problemSelected + ' shipment Problem Comments can\'t be blank', 'Warning!');
      return;
    }
    if(this.addressToShipFirstName == "" || this.addressToShipLastName == "" || this.addressToShipToEmail == "" || this.addressToShipToPhone == "" ){
      this.displayFailureMsg(this.problemSelected + ' shipment report model is not valid. Please ensure First & Last Name, Phone Number, Email are all being sent.', 'Warning!');
      return;
    }
    if((this.problemSelected == 'Damaged' || this.problemSelected == 'Wrong') && this.fileIds.length==0){
      this.displayFailureMsg(this.problemSelected + ' shipment sku images should be uploaded', 'Warning!');
      return;
    }
    if((this.addressToShipToEmail || this.addressToShipToEmail.trim().length > 0) && !this.validateEmail(this.addressToShipToEmail)){
      this.displayFailureMsg('Entered email address is not valid', 'Warning!');
       return;
    }
    const rogToUpdate = new RogDetailInput();
    let selectedProblem = '';
    rogToUpdate.accountNumber = this.rogDetail.accountNumber;
    rogToUpdate.orderNumber =  this.rogDetail.orderNumber;
    rogToUpdate.receiptOfGoodsId = this.rogDetail.id;
    this.linesSelected.forEach(line => {
      const updatedSku = new RogSkuDetail();
      updatedSku.id = line.id;
      updatedSku.status = this.problemSelected;
      updatedSku.comments = this.problemComment;
      updatedSku.sku = line.sku;
      updatedSku.parentSku = line.parentSku;
      updatedSku.deliveryQty = line.deliveryQty;
      updatedSku.mpn = line.mpn;
      updatedSku.deliveryNumber = line.deliveryNumber;
      updatedSku.imageIds = this.fileIds;
      updatedSku.problemQty = this.problemQty;

      updatedSku.addressToShipToLine1 = this.addressToShipToLine1;
      updatedSku.addressToShipToLine2 = this.addressToShipToLine2;
      updatedSku.addressToShipToCity = this.addressToShipToCity;
      updatedSku.addressToShipToState = this.addressToShipToState;
      updatedSku.addressToShipToPostalCode = this.addressToShipToPostalCode;

      updatedSku.damageOnBolNo = this.damageonbol;
      updatedSku.packagingDamaged = this.packagedamaged;
      updatedSku.keepExcess = this.keepexcess;
      updatedSku.replacementDeliveryDate = this.replacementDate;
      updatedSku.reportedByFirstName = this.reportedByFirstName;
      updatedSku.reportedByLastName = this.reportedByLastName;
      updatedSku.addressToShipFirstName = this.addressToShipFirstName;
      updatedSku.addressToShipLastName = this.addressToShipLastName;
      updatedSku.addressToShipToPhone = this.addressToShipToPhone;
      updatedSku.addressToShipToEmail = this.addressToShipToEmail;
      updatedSku.addressToShipCompanyName = this.addressToShipCompanyName;
      updatedSku.liftGateRequired = this.liftgaterequired;
      updatedSku.sameShipmentAddress = this.sameshipmentaddress;
      rogToUpdate.receiptOfGoodsSkus.push(updatedSku);
    });
    
    this.tasksService.updateRogTask(rogToUpdate).subscribe(response => {
      this.sendDataToAnalytics(this.linesSelected[0].sku,  this.problemSelected.toLowerCase());
      this.onUpdateSuccess(null);
      this.fetchRogAndFillComments();
      this.getTimer();
      this.problemSelected = '';
      this.problemComment = '';
      this.problemQty = 0;
      this.fileIds = [];
      // this.linesTable.setStatus(this.linesSelected, this.problemSelected);
    }, error => {
      const err = error.error;
      this.onUpdateError(err.message);
    });
  }

  private sendDataToAnalytics(skus:string, selectedProblem: string) {
    this.analyticsService.trackSKUOrderConfirmation(skus + "-" + selectedProblem);
  }

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  fillComments() {
    this.comments = [];
    this.rogDetail.rogProblemDetails.forEach(item => {
      const rogSku = this.rogDetail.receiptOfGoodsSkus.find(rogs => rogs.id === item.rogSkuId);
      if(rogSku){
        this.comments.push({ sku: item.sku, parentSku: rogSku.parentSku, status: item.status, qty: item.quantity, deliveryQty: rogSku.deliveryQty, text: item.comment, files: item.imageId, receiptOfGoodsSkuId: item.rogSkuId });
      }
    });
  }

  previewFile(fileId: string) {
    const modalRef = this.modalService.open(PreviewImageComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.fileId = fileId;
  }

  openPopupForRetract(comment) {
    const modalRef = this.modalService.open(RetractModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.sku = comment.sku;
    modalRef.componentInstance.status = comment.status;
    modalRef.componentInstance.qty = comment.qty;
    modalRef.componentInstance.fn = (retractComment) => {
      modalRef.close();
      let rogRetract = this.setRogRetractFields(comment, retractComment);
      this.tasksService.sendRogRetractMail(rogRetract).subscribe(response => {
        //No action to be performed
      }, 
        error => {
        if(error instanceof HttpErrorResponse) {
          if(error.status === 200) {
          
            this.onUpdateSuccess(error.error.text);
            this.fetchRogAndFillComments();
          }else{
            this.displayFailureMsg(error.error, 'Fail!');
          }
        }
      });
    };
    
  }

  private fetchRogAndFillComments() {
    this.tasksService.getRog(this.rogDetail.accountNumber, this.rogDetail.orderNumber).subscribe(result => {
      this.rogDetail = result;
      this.setDescriptionForRogSkus();
      this.fillComments();
      this.rogDetail.receiptOfGoodsSkus.forEach(line => {
        const item = result.receiptOfGoodsSkus.find(rogs => rogs.id === line.id);
        if (item) {
          line.status = item.status;
        }
      });
    });
  }

  setRogRetractFields(comment, retractComment){
    let rogRetract = new RogRetract();
    rogRetract.sku = comment.sku;
    rogRetract.parentSku = comment.parentSku;
    rogRetract.status = comment.status;
    rogRetract.quantity = comment.qty;
    rogRetract.siteName = this.order.projectName;
    rogRetract.retractionComment = retractComment;
    rogRetract.marketName = this.market.name;
    rogRetract.orderNumber = this.rogDetail.orderNumber;
    rogRetract.rogId = this.rogDetail.id;
    rogRetract.projectName = this.order.projectName;
    rogRetract.accountNumber = this.rogDetail.accountNumber;
    rogRetract.receiptOfGoodsSkuId = comment.receiptOfGoodsSkuId;
    comment.text = retractComment;

    this.order.orderItems.forEach(line => {
      if(line.sku === comment.sku){
        rogRetract.partNumber = line.mpn;
        rogRetract.partDescription = line.itemDescription;
      }
    });
    return rogRetract;
  }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      this.backToSearch = params['backToSearch'];
    });
    this.setInitialMinAndMaxDate();
    this.route.params.subscribe(params => {
      this.projectService.getProjectByNameAndAccountNumber(params.projectName, params.accountNumber).subscribe(p => {
        let project = p;
        this.marketService.getMarketById(project.marketId).subscribe(market => {
          this.market = market;
        });
        if (this.userService.isMarketPermittedForCurrentUser(project.marketId)) {
          forkJoin(
            this.projectService.getOrderConfirmationV2(new ProjectOrderInput(params.projectName, params.accountNumber, params.orderNumber, localStorage.getItem("marketLocationCode"))),
            //this.tasksService.getRogsByProject(params.projectName)
            this.tasksService.getRog(params.accountNumber, params.orderNumber)
          ).subscribe(result => {
            this.order = result[0].orders[0];
            this.rogDetail = result[1];
            if (this.rogDetail != null && this.rogDetail.receiptOfGoodsSkus != null &&
              this.rogDetail.receiptOfGoodsSkus.length > 0) {
              this.setDescriptionForRogSkus();
              this.fillComments();
              this.rogTaskDetails = true;
            }
            this.loading = false;
          });
        } else {
          this.loading = false;
          this.errorMessage.push("You don't have permission to view this page!!!");
        }
      });
    });

    this.userService.findUserById(this.authService.getUserId()).subscribe((user: User) => {
      this.reportedByFirstName = user['First Name'];
      this.reportedByLastName = user['Last Name'];
      this.submittedByFirstName = user['First Name'];
      this.submittedByLastName = user['Last Name'];
      this.userDetails = user;
    });

  }

  getTimer() {
    if (this.rogDetail) {
      let hours = Math.round((new Date(this.rogDetail.expectedCompletion).getTime() - new Date().getTime()) / (1000 * 60 * 60));
      if (hours <= 0) {
        if (this.allLinesHaveStatus()) {
          return 'Receipt of Goods Confirmed';
        } else {
          return 'Time expired for Confirm Receipt';
        }
      } else {
        if (this.allLinesHaveStatus()) {
          return 'Receipt of Goods Confirmed';
        } else {
          if (hours <= 72) {
            return `${hours} HRS Remaining to Confirm Receipt`;
          }
        }
      }
    }
  }

  setDescriptionForRogSkus() {
    this.comments = [];
    this.rogDetail.receiptOfGoodsSkus.forEach(item => {
      const rogSku = this.order.orderItems.find(rogs => rogs.sku === item.sku);
      if(rogSku && rogSku.itemDescription){
        item.description = rogSku.itemDescription;
      }
    });
  }

  setInitialMinAndMaxDate() {
    // Setting Minimum date
    var businessdays = new Date().getDay()>=3 ? 5 : 3;
    this.minDate = this.calendar.getNext(this.calendar.getToday(), 'd', businessdays);
  }

  onExcessChange(selectedValue){
    this.keepexcess = selectedValue;
    return this.keepexcess;
  }

  onPackageDamageChange(selectedValue){
    this.packagedamaged = selectedValue;
    return this.packagedamaged;
  }
  onBolDamageChange(selectedValue){
    this.damageonbol = selectedValue;
    return this.damageonbol;
  }

  removeImage(){
    this.fileIds = [];
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-confirmation/order-confirmation.component.ts